import { render } from "./Fanart.vue?vue&type=template&id=fb63455c"
import script from "./Fanart.vue?vue&type=script&lang=js"
export * from "./Fanart.vue?vue&type=script&lang=js"

import "./Fanart.vue?vue&type=style&index=0&id=fb63455c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__